<template>
    <div id="prequalify-page" class="gradbg">
        <div class="header-panel">
            <h1>Get Pre-Qualified for a Mortgage</h1>
        </div>
        <div class="content-panel">
            <div class="logo">
                <img src="../assets/bank-generic-logo.png" alt="">
            </div>
            <div class="content">
                <p>Take this first step and find out how much you're qualified to receive.</p>

                <p>To get started, you'll need to know:</p>

                <ul>
                    <li>Your total monthly income</li>
                    <li>Your total monthly expenses</li>
                    <li>Anticipated house price</li>
                    <li>Anticipated down payment amount</li>
                    <li>Your employment history</li>    
                </ul>

                <form @submit.prevent="submit">
                    <div class="field">
                        <label>First name</label>
                        <input type="text">
                    </div>
                    <div class="field">
                        <label>Middle name</label>
                        <input type="text">
                    </div>
                    <div class="field">
                        <label>Last name</label>
                        <input type="text">
                    </div>
                    <div class="field">
                        <label>Address</label>
                        <input type="text">
                    </div>
                    <div class="field">
                        <label>City</label>
                        <input type="text">
                    </div>
                    <div class="field">
                        <label>State</label>
                        <select>
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="DC">District Of Columbia</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                        </select>				
                    </div>
                    <div class="field">
                        <label>Zip</label>
                        <input type="text">
                    </div>
                    <div class="buttons">
                        <button class="bluebtn">Next</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'prequalify-page',
    data() {
        return {
        }
    },
}
</script>
<style lang="scss">
#prequalify-page {
    .header-panel h1 {
        font-size: 18px;
    }

    p {
        text-align: left;
        font-size: 14px;
        margin: 1rem 0;
    }

    ul {
        list-style: disc outside;
        margin-bottom: 1.5rem;
        margin-left: 1.5rem;
        text-align: left;
        
        li {
            font-size: 14px;
        }
    }

    label {
        text-align: left;
    }
    .field {
        select {
            flex: 1 1 50%;
        }
    }

    .content-panel {
        background: white;
        padding: 16px;

        .logo {
            max-width: 250px;
            display: block;
            margin: 0 auto;
        }
    }

}
</style>
